<router-outlet></router-outlet>

<fuse-loading-bar></fuse-loading-bar>
